import React, { Suspense, lazy } from "react"
import { Navigate } from "react-router-dom"
import ProtectedRoute from "routes/ProtectedRouteWrapper"

// PRISMS MODULE
import NotificationCenterPrisms from "pages/PrismsModule/NotificationCenter/Home"
//
import StaffAttendance from "pages/TeacherApp/DailyAttendance/Home"
// Profile
import UserProfile from "../pages/Authentication/user-profile"
import LeaveAuthority from "../pages/TeacherApp/LeaveApp/LeaveAuthority"
import LMS from "pages/TeacherApp/LMS/Home"
// STUDENT LEAVE REPORT FOR TEACHER APP :
import StudentLeaveReportTeacher from "../pages/TeacherApp/LeaveApp/StudentLeaveReport"
// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import NewNotifiationCenter from "../pages/TeacherApp/NotificationCenterNew/Home"
// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Comingsoon from "components/Common/CommingSoon"
import ExternalLinks from "pages/ExternalLinks"
import Notifications from "pages/Notifications/View"
import FeedBack from "pages/Feedback"
import CreateFeedback from "pages/Feedback/CreateFeedback"
import ChatWindow from "pages/Feedback/ChatWindow"
import MediaView from "components/Common/MediaView"
import HandleRoutes from "pages/HandleRoutes"
import CreateNotifications from "pages/Notifications/Create"
import ViewTimeTable from "pages/TimeTable/View"
import PaidFeesDetails from "pages/Fees/PaidFeesDetails"
import PrintRecipt from "pages/Fees/PaidFeesDetails/PrintRecipt"
import Attendance from "pages/Attendance/Teacher"
import Gallery from "pages/Gallery"
import ImageGallery from "pages/Gallery/ImageGallery"

import StudentProfilePicCrop from "pages/TeacherApp/StudentProfile/CropImage"
// Exam Fill Marks for Teacher

import ExamFillMarker from "pages/TeacherApp/FillexamMarks/Home"
import ClassTestMarks from "pages/TeacherApp/ClassTestMarks/Card"
import SingleClassTest from "pages/TeacherApp/ClassTestMarks/MarksOfStud"
// Access Subject Report
import ClassTestHome from "pages/TeacherApp/ClassTestMarks/Home"
import CreateTest from "pages/TeacherApp/ClassTestMarks/CreateTest"
import AccessHome from "pages/TeacherApp/SubjectAccess/SubjectHome"
import SubjectAccess from "pages/TeacherApp/SubjectAccess/Home"
import SubjectAccessReport from "pages/TeacherApp/SubjectAccess/Report"
import PDFView from "pages/PDF/Home"
// TEACHER APP - Routes
// Leave Apply for Teacher
import TeacherLeaveApp from "pages/TeacherApp/LeaveApp/Home"
import LeaveRequest from "pages/TeacherApp/LeaveApp/ApplyLeave"
import LeaveHistory from "pages/TeacherApp/LeaveApp/LeaveReport"
import StudentLeave from "pages/Report/LeaveReport"
import StudentLeaveHome from "pages/STUDENT/StudentLeave/Home"
// Teacher Pofile App
import TeacherProfile from "pages/TeacherApp/TeacherProfile/Home"

import Anecdotal from "pages/TeacherApp/Anecdotal/Home/Home"
import AddAnecdotal from "pages/TeacherApp/Anecdotal/Form/Home"
import AnecdotalReport from "pages/TeacherApp/Anecdotal/Report/Home"
import EventWiseReport from "pages/TeacherApp/Anecdotal/Report/EventWiseReport"
import MonthWiseReport from "pages/TeacherApp/Anecdotal/Report/SubjectMonthReport"
// Visitor App
import VisitorApp from "pages/TeacherApp/Visitor/Home"
import VisiorManullay from "pages/TeacherApp/Visitor/Manullay"
import VisitorScanner from "pages/TeacherApp/Visitor/NewScanner"

import CheckoutHome from "pages/TeacherApp/Visitor/CheckoutHome"
// Visitor App
import AttendanceReport from "pages/Attendance/Teacher/Report"

// Calendar App
import DocHome from "pages/STUDENT/Doc/Home"
import DocRepo from "pages/STUDENT/Doc/SingleView"
import DocSub from "pages/STUDENT/Doc/SubFolder"
import CalendarHome from "pages/TeacherApp/Calendar/Home"

// STUDENT PROFILE :
import StudentLeaveReport from "pages/STUDENT/StudentLeave/LeaveReport"
import StudentProfile from "pages/TeacherApp/StudentProfile/Home"
import StudentProfileApp from "pages/STUDENT/ProfileApp/Home"

import StudentPortfolioReport from "pages/STUDENT/Portfolio/Student/Home"
import StudentPortfolioDownload from "pages/STUDENT/Portfolio/Student/Report"
import TeacherPortfolioReport from "pages/TeacherApp/Portfolio/Report"

import AssignmentDeatils from "pages/STUDENT/Assignment/AssignmentDeatils"
import SubmitAssignment from "pages/STUDENT/Assignment/Submit"
import SubmittedAssignmentDeatils from "pages/STUDENT/Assignment/SubmittedReport"
import SubmitRemark from "pages/TeacherApp/Assignment/Remark"
// Assignment
import AssigmentHome from "pages/TeacherApp/Assignment/Home"
import CreateAssignment from "pages/TeacherApp/Assignment/CreateAssignment"
import AssignmentReport from "pages/TeacherApp/Assignment/Report"
import ViewAssignmentStundent from "pages/TeacherApp/Assignment/ViewSingleAssingment"
import StudentsAssignment from "pages/TeacherApp/Assignment/StudentAssignment"
import ReportCard from "pages/STUDENT/ReportCard/Home"
import ReportResult from "pages/STUDENT/ReportCard/ReportCard"

import StudentAssignmentHome from "pages/STUDENT/Assignment/Home"
// Fees :
import StudentClassTest from "pages/STUDENT/ClassTest/Home"
import Fees from "pages/TeacherApp/FeesReport/Home"
import NotesUpload from "pages/TeacherApp/NotesUpload/Home"
import FeesDetails from "pages/TeacherApp/FeesReport/Report"

// Student App
import StudentNotes from "pages/STUDENT/NotesApp/Notes"
import StudentLeaveApp from "pages/STUDENT/StudentLeave/Home"
import StudentLeaveApply from "pages/STUDENT/StudentLeave/ApplyLeave"
// import StudentLeaveReport  from "pages/STUDENT/StudentLeave/LeaveReport"
// Gallery
import GalleryStud from "pages/STUDENT/GalleryApp/Home"
import ListOfImages from "pages/STUDENT/GalleryApp/ImageList"

import OnlineFess from "pages/STUDENT/OnlinePayment/Home"
import SM from "pages/TeacherApp/Visitor/ScanM"
// Log Sheet
import LogSheet from "pages/TeacherApp/LogS/Home"
import LogsheetTimetable from "pages/TeacherApp/LogS/TimeTable"
import LogSheetSubmit from "pages/TeacherApp/LogS/SubmitLog"
import LogSheetReport from "pages/TeacherApp/LogS/LogReport"
import Campign from "pages/Camping/Home"
// Teacher Remark Module:
import RemarkHome from "pages/TeacherApp/Remark/Home"
import Holidays from "pages/STUDENT/Holiday/Home"
import CustomEditComponent from "pages/STUDENT/ProfileApp/Doc/CustomEdit"
import DynamicEditComponent from "pages/STUDENT/ProfileApp/Doc/Dynamic"
// ADMIN APP ROUTES : -

// 1. SCHEDULE NOTIFICATION - /admin/schedule/
import ScheduleNotification from "pages/Admin/ScheduleNotification/Home"
// 2. REVIEW NOTIFICATION - /admin/review/notifications
import ReviewNotification from "pages/Admin/ReviewNotfification/Home"
import TeacherFeedback from "pages/Feedback/Teacher"

// Transport

// Lesson Plan

import LessonHome from "pages/TeacherApp/LessonPlan/Home/Home"
import LessonPlan from "pages/TeacherApp/LessonPlan/Home/Lesson"
import LessonReport from "pages/TeacherApp/LessonPlan/Report/Report"

import TransportHome from "pages/Transport/Home"
import PickUp from "pages/Transport/Scanner/Pickup"
import Pscan from "pages/Transport/Scanner/Scan"
// Video Channel Tab

import VideoChannel from "pages/Video/Home"
import VideoLink from "pages/Video/Video"
import AnnouncementNotifications from "pages/Notifications/Announcement/View"
import HomeWorkNotifications from "pages/Notifications/HomeWork/View"
import HeicViewerPage from "pages/Test/Page"
import ClassWorkTeacher from "pages/ClassWorkLessonPlan/Teacher"
import ClassWorkStudent from "pages/ClassWorkLessonPlan/Student"
import ClassWorkAdmin from "pages/ClassWorkLessonPlan/Admin"
import QueryForm from "../common/QuerySubmit"
import StudentDoc from "pages/STUDENT/ProfileApp/Doc/Home"
import GatePassApprovalMapping from "pages/GatePass/Admin/GatePassApprovalMapping"
import GatePassApprovals from "pages/GatePass/Admin/GatePassApprovals"
import GatePassCheckInOut from "pages/GatePass/Admin/GatePassCheckInOut"
import GatePassTeacher from "pages/GatePass/Teacher/GatePassTeacher"
import GatePassReport from "pages/GatePass/Admin/GatePassReport"
import NotAuthorized from "components/Common/ModuleNotAuth"
import AdminFeedBack from "pages/Feedback/Admin"
// 3. ATTENDANCE - /admin/attendance
// 4. TIME TABLE - /admin/time-table
// 5. Feedback - /admin/feedback/notifications
// 6. Upload Student Avatar - /admin/upload-student-avatar
// 7. Fees  - /admin/review/notifications

import StudentNewDashboard from "pages/StudentNewDashboard/Home"
import AdminNewDashboard from "pages/AdminNewDashboard/Home"
import TeacherNewDashboard from "pages/TeacherNewDashboard/Home"

const RoleBaseDashboard = () => {
  const userID = localStorage.getItem("group_id")
  switch (userID) {
    case "10":
      return <AdminNewDashboard />
    case "9":
      return <TeacherNewDashboard />
    case "2":
      return <StudentNewDashboard />
    default:
      return <div className="page-content">Unauthorized Access</div>
  }
}

const authProtectedRoutes = [
  // { path: "/categories", component: <Dashboard /> },
  // { path: "/dashboard", component: <RoleBaseDashboard /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/not-authorized", component: <NotAuthorized /> },
  { path: "/student-doc", component: <StudentDoc /> },
  { path: "/custom-edit", component: <CustomEditComponent /> },
  { path: "/dynamic-edit", component: <DynamicEditComponent /> },
  { path: "/dashboard/parent", component: <Dashboard /> },
  { path: "/dashboard/teacher", component: <Dashboard /> },
  { path: "/dashboard/admin", component: <Dashboard /> },
  { path: "/video/channel", component: <VideoChannel /> },
  { path: "/video/channel/:id", component: <VideoLink /> },
  { path: "/teacher/leave-authority", component: <LeaveAuthority /> },
  { path: "/staff-attendance", component: <StaffAttendance /> },

  //Utilities
  { path: "/external-link", component: <ExternalLinks /> },
  { path: "/media-preview", component: <MediaView /> },
  {
    path: "/campaign",
    component: <ProtectedRoute component={Campign} modulePath={"/campaign"} />,
  },
  { path: "/handleroutes", component: <HandleRoutes /> },
  {
    path: "/profile",
    component: (
      <ProtectedRoute component={UserProfile} modulePath={"/profile"} />
    ),
  },
  {
    path: "/notifications",
    component: (
      <ProtectedRoute component={Notifications} modulePath={"/notifications"} />
    ),
  },
  {
    path: "/announcements-notifications",
    component: <AnnouncementNotifications />,
  },
  { path: "/lesson-home", component: <LessonHome /> },
  { path: "/lesson-Plan", component: <LessonPlan /> },
  { path: "/lesson-report", component: <LessonReport /> },
  { path: "/homework-notifications", component: <HomeWorkNotifications /> },
  { path: "/create-notifications", component: <CreateNotifications /> },
  { path: "/transport-home", component: <TransportHome /> },
  { path: "/transport/pickup/:sid/:staff_id", component: <PickUp /> },
  {
    path: "/feedback",
    component: <ProtectedRoute component={FeedBack} modulePath="/feedback" />,
  },
  { path: "/teacher-feedback", component: <TeacherFeedback /> },
  { path: "/feedback/create", component: <CreateFeedback /> },
  { path: "/feedback/chats", component: <ChatWindow /> },
  { path: "/teacher-feedback/chats", component: <ChatWindow /> },
  { path: "/admin-feedback", component: <AdminFeedBack /> },
  { path: "/admin-feedback/chats", component: <ChatWindow /> },
  { path: "/crop", component: <StudentProfilePicCrop /> },
  {
    path: "/timetable",
    component: (
      <ProtectedRoute component={ViewTimeTable} modulePath="/timetable" />
    ),
  },
  {
    path: "/teacher/student/leave-report",
    component: <StudentLeaveReportTeacher />,
  },
  {
    path: "/paidfeesdetails",
    component: (
      <ProtectedRoute
        component={PaidFeesDetails}
        modulePath={"/paidfeesdetails"}
      />
    ),
  },
  {
    path: "/printpaidfeesdetails",
    component: (
      <ProtectedRoute
        component={PrintRecipt}
        modulePath={"/printpaidfeesdetails"}
      />
    ),
  },
  {
    path: "/fees/payment",
    component: (
      <ProtectedRoute component={OnlineFess} modulePath={"/fees/payment"} />
    ),
  },
  {
    path: "/report/card",
    component: (
      <ProtectedRoute component={ReportCard} modulePath={"/report/card"} />
    ),
  },
  {
    path: "/student-portfolio/report",
    component: (
      <ProtectedRoute
        component={StudentPortfolioReport}
        modulePath={"/student-portfolio/report"}
      />
    ),
  },
  { path: "/student/apply-leave", component: <StudentLeaveApply /> },
  { path: "/fill/remark", component: <RemarkHome /> },
  { path: "/student/Leave-report", component: <StudentLeaveReport /> },
  { path: "/teacher/attendance", component: <Attendance /> },
  { path: "/teacher/attendance-report", component: <AttendanceReport /> },
  { path: "/gallery", component: <Gallery /> },
  { path: "/teach", component: <LMS /> },
  {
    path: "/document/repository",
    component: (
      <ProtectedRoute component={DocHome} modulePath={"/document/repository"} />
    ),
  },
  { path: "/document/repository/:id", component: <DocRepo /> },
  {
    path: "/student/holidays",
    component: (
      <ProtectedRoute component={Holidays} modulePath={"/student/holidays"} />
    ),
  },
  { path: "/document/sub/:id/:repoId", component: <DocSub /> },
  { path: "/gallery/images", component: <ImageGallery /> },
  {
    path: "/student/gallery",
    component: (
      <ProtectedRoute component={GalleryStud} modulePath={"/student/gallery"} />
    ),
  },
  { path: "/gallery-images/:id", component: <ListOfImages /> },
  { path: "/teacher/fill/marks", component: <ExamFillMarker /> },
  { path: "/class-test/marks", component: <ClassTestHome /> },
  { path: "/create-class-test", component: <CreateTest /> },
  { path: "/teacher-class-test", component: <ClassTestMarks /> },
  { path: "/class-test/marks/:id", component: <SingleClassTest /> },
  { path: "/subject-access-request", component: <AccessHome /> },
  { path: "/subject-access", component: <SubjectAccess /> },
  { path: "/subject-access-report", component: <SubjectAccessReport /> },
  { path: "/staff-profile", component: <TeacherProfile /> },
  { path: "/student-leave-report", component: <StudentLeave /> },
  { path: "/student-profile/pic", component: <StudentProfile /> },
  { path: "/student-profile", component: <StudentProfileApp /> },
  { path: "/fees", component: <Fees /> },
  { path: "/fees/details/:user_id/:id", component: <FeesDetails /> },
  { path: "/teacher/leave", component: <TeacherLeaveApp /> },
  { path: "/teacher/apply-leave", component: <LeaveRequest /> },
  { path: "/teacher/leave-history", component: <LeaveHistory /> },
  { path: "/visitor-home", component: <VisitorApp /> },
  { path: "/visitor-manually", component: <VisiorManullay /> },
  { path: "/visitors", component: <CheckoutHome /> },
  { path: "/calendar", component: <CalendarHome /> },
  {
    path: "/Assignment/home",
    component: (
      <ProtectedRoute
        component={AssigmentHome}
        modulePath={"/Assignment/home"}
      />
    ),
  },
  { path: "/create-assignment", component: <CreateAssignment /> },
  { path: "/students-assignment", component: <StudentsAssignment /> },
  { path: "/assignment-report", component: <AssignmentReport /> },
  { path: "/view-assignment/:id", component: <ViewAssignmentStundent /> },
  { path: "/class-test", component: <StudentClassTest /> },
  { path: "/student-assignment", component: <StudentAssignmentHome /> },
  { path: "/assignment", component: <AssignmentDeatils /> },
  {
    path: "/student-submitted-assignmet",
    component: <SubmittedAssignmentDeatils />,
  },
  { path: "/assignmet-remark/:id", component: <SubmitRemark /> },

  { path: "/submit-assignment/:id", component: <SubmitAssignment /> },
  { path: "/pdf-view/:id", component: <PDFView /> },
  { path: "/scan", component: <SM /> },
  // {path: "/Portfolio", component: <PortfilioHome/>},
  { path: "/teacher-portfolio-report", component: <TeacherPortfolioReport /> },
  // {path: "/create-portfolio", component: <CreatePortfolio/>},
  { path: "/LogSheet", component: <LogSheet /> },
  { path: "/log-time", component: <LogsheetTimetable /> },
  { path: "/log-sheet/:id", component: <LogSheetSubmit /> },
  { path: "/log-report", component: <LogSheetReport /> },
  { path: "/notes/upload", component: <NotesUpload /> },
  {
    path: "/student/notes",
    component: (
      <ProtectedRoute component={StudentNotes} modulePath={"/student/notes"} />
    ),
  },
  { path: "/anecdotal", component: <Anecdotal /> },
  { path: "/create/anecdotal", component: <AddAnecdotal /> },
  { path: "/anecdotal/report", component: <AnecdotalReport /> },
  { path: "/anecdotal/Event/report", component: <EventWiseReport /> },
  { path: "/anecdotal/month/report", component: <MonthWiseReport /> },
  { path: "/student/leave", component: <StudentLeaveApp /> },
  { path: "/new/notifications", component: <NewNotifiationCenter /> },
  { path: "/student/leave", component: <StudentLeaveHome /> },
  { path: "/t", component: <HeicViewerPage /> },

  // Class work lesson plan routes
  { path: "/class-work/teacher", component: <ClassWorkTeacher /> },
  { path: "/class-work/student", component: <ClassWorkStudent /> },
  { path: "/class-work/admin", component: <ClassWorkAdmin /> },

  // ADMIN APP ROUTES --
  { path: "/schedule/notifications", component: <ScheduleNotification /> },
  { path: "/review/notifications", component: <ReviewNotification /> },

  {
    path: "/gatepass-approval-mapping",
    component: <GatePassApprovalMapping />,
  },
  { path: "/gatepass-approval", component: <GatePassApprovals /> },
  { path: "/gatepass-check-in-out", component: <GatePassCheckInOut /> },
  { path: "/gatepass-teacher", component: <GatePassTeacher /> },
  { path: "/gatepass-report", component: <GatePassReport /> },

  {
    path: "*",
    component: <Comingsoon />,
  },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const publicRoutes = [
  { path: "/transport/pickup/student/:sid/:staff_id", component: <Pscan /> },
  { path: "/visitor-scanner", component: <VisitorScanner /> },
  { path: "/report/card/details", component: <ReportResult /> },

  { path: "/web/feedback", component: <FeedBack /> },
  { path: "/web/teacher-feedback", component: <TeacherFeedback /> },
  { path: "/web/feedback/create", component: <CreateFeedback /> },
  { path: "/web/feedback/chats", component: <ChatWindow /> },
  { path: "/web/teacher-feedback/chats", component: <ChatWindow /> },
  { path: "/web/admin-feedback", component: <AdminFeedBack /> },
  { path: "/web/admin-feedback/chats", component: <ChatWindow /> },
  
  { path: "/report", component: <StudentPortfolioDownload /> },
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/notification/center/app", component: <NotificationCenterPrisms /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/support", component: <QueryForm /> },
]

export { authProtectedRoutes, publicRoutes }
